import React from "react";
import FormExperiences from "./FormExperiences";
import FormReferences from "./FormReferences";
import AddButton from "./element/AddButton";

function FormRightContainer({ contents, updateData, addData, removeData }) {
  function handleClick(e) {
    addData({ category: e.target.name });
  }

  return (
    <>
      {contents.map((content, index) => {
        if (content.type === "experience") {
          return (
            <FormExperiences
              key={content.id}
              id={index}
              experiences={content}
              updateData={updateData}
              addData={addData}
              removeData={removeData}
            />
          );
        } else if (content.type === "reference") {
          return (
            <FormReferences
              key={content.id}
              id={index}
              references={content}
              updateData={updateData}
              addData={addData}
              removeData={removeData}
            />
          );
        }
      })}{" "}
      <div className="column-add-container flex flex-col justify-center items-center">
        <div className="text-lg ">Add Section</div>
        <div className=" flex gap-4">
          {" "}
          <AddButton
            handleAdd={handleClick}
            name="experienceSection"
            text={"Experience"}
          />
          <AddButton
            handleAdd={handleClick}
            name="referenceSection"
            text={"Reference"}
          />
        </div>
      </div>
    </>
  );
}
export default FormRightContainer;
